import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCompletedTaskProducts, sendEmail } from "../../app/api";
import { Button, Descriptions, Input, Spin, Table } from "antd";
import { toast } from "react-toastify";

const ProductsByTask = () => {
    const { taskId } = useParams();
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState(null);
    const [email, setEmail] = useState("");
    const [emailLoading, setEmailLoading] = useState(false);

    const productsColumns = [
        {
            title: 'Անվանում',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Քանակ',
            dataIndex: 'count',
            key: 'count',
            render: (count) => (count || 1) ?? "Չի նշված",
        },
        {
            title: 'Գին',
            dataIndex: 'price',
            key: 'price',
            render: (price, record) => {
                if (price != null) {
                    const totalPrice = record.count ? price * record.count : price;
                    return `${price} ֏ (${totalPrice} ֏)`;
                }
                return "";
            },
        }
    ];

    const items = [
        {
            key: '1',
            label: 'Ընդհանուր Աշխատանքի Գումարը',
            span: 3,
            children: products?.totalAmount !== undefined 
                ? (
                    <strong style={{ color: 'red', fontSize: '16px' }}>
                        {new Intl.NumberFormat('hy-AM', { style: 'currency', currency: 'AMD' }).format(products.totalAmount)}
                    </strong>
                ) 
                : "Անհայտ",
        },
        {
            key: '2',
            label: 'Ապրանքներ',
            span: 3,
            children: products?.products.length ? (
                <Table
                    columns={productsColumns}
                    dataSource={products?.products}
                    pagination={false}
                    rowKey="id"
                    bordered={true}
                    style={{ width: "100%" }}
                    footer={() => {
                        const totalPrice = products.products.reduce((sum, record) => sum + (record.price * record.count || record.price), 0);
                        const finalAmount = totalPrice + products.totalAmount;
                    
                        return (
                            <div style={{ padding: '10px 16px' }}>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'space-between', 
                                    fontWeight: 'bold',
                                    borderBottom: '1px solid black',
                                    paddingBottom: '4px'
                                }}>
                                    <div>Ընդհանուր</div>
                                    <div />
                                    <div style={{ textAlign: 'right', color: 'red' }}>{totalPrice} ֏</div>
                                </div>
                                
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontWeight: 'bold' }}>
                                    <div>Ենթակա վճարման գումար</div>
                                    <div/>
                                    <div style={{ textAlign: 'right', color: 'green' }}>
                                        {finalAmount} ֏
                                    </div>
                                </div>
                          </div>
                        );
                    }}
                />
            ) : "Անհայտ",
        }
    ]

    const handleClick = async () => {
        setEmailLoading(true);
        try {
            const request = await sendEmail({
                to: email,
                productId: Number(taskId)
            });
            if (request.data.success) {
                setEmail("");
                toast.success(request?.data?.message);
            }
        } catch(err) {
            console.log(err, "Error message");
        } finally {
            setEmailLoading(false);
        }
    }

    const fetchProducts = async () => {
        setLoading(true);
        try {
            const allData = await getCompletedTaskProducts(taskId);
            if (allData.status === 200) {
                setProducts(allData.data);
            }
        } catch (error) {
            console.error("Failed to fetch car details", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProducts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', }}>
            {loading ? (
                <Spin size="large" tip="Բեռնվում է..." />
            ) : (
                <div style={{ width: '100%', maxWidth: '1000px', padding: '20px' }}>
                    <Descriptions title="Ապրանքագիր" layout="vertical" items={items} />
                    <div style={{ marginTop: '40px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                        <h3>Ուղարկել էլեկտրոնային հասցեին</h3>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                        <Input
                            type="email"
                            placeholder="Մուտքագրեք էլ․ փոստը"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                width: '250px',
                                fontSize: '16px',
                            }}
                        />
                        <Button
                            type="primary"
                            onClick={handleClick}
                            loading={emailLoading}
                            disabled={!email}
                        >
                            Ուղարկել
                        </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProductsByTask;